import Cookie from '@common-vue/util/src/modules/cookie/Cookie';

const isApplyNowFlowActive = () => {
  try {
    const applyNowDataString = sessionStorage.getItem('applyNow');

    if (!applyNowDataString) {
      return false;
    }

    const { value, expiry } = JSON.parse(applyNowDataString);

    if (Date.now() > expiry) {
      sessionStorage.removeItem('applyNow');
      return false;
    }

    return value === 'true';
  } catch (e) {
    sessionStorage.removeItem('applyNow');
    return false;
  }
};

const isCurrentPathSame = () => {
  try {
    const forwardPage = Cookie.get('FORWARDPAGE_KEY');

    if (!forwardPage) {
      return false;
    }

    const decodedForwardPage = decodeURIComponent(forwardPage);
    const forwardPath = new URL(
      decodedForwardPage,
      window.location.origin,
    ).pathname;

    return window.location.pathname === forwardPath;
  } catch (e) {
    try {
      const forwardPage = Cookie.get('FORWARDPAGE_KEY');

      if (!forwardPage) {
        return false;
      }

      return window.location.pathname === decodeURIComponent(forwardPage);
    } catch {
      return false;
    }
  }
};

function getCookie(name, subCookieName) {
  try {
    let value = (
      document.cookie.match(
        new RegExp(`(?:^|;\\s*)${name}=([^;]+)`),
      ) || []
    )[1];

    if (value && subCookieName) {
      // 3_87_ => separates subcookies
      // 1_92_ => separates cookie name and value
      // 4_02_ => empty value
      value = (
        value.match(
          new RegExp(
              `(?:^|3_87_)${subCookieName}1_92_(?!4_02_)(.+?)(?=3_87_|$)`,
          ),
        ) || []
      )[1];
    }

    return value;
  } catch (e) {
    return undefined;
  }
}

function isSignedInOrSoftSignedIn() {
  try {
    if (getCookie('SignedIn') === '1') {
      return true;
    }

    const userName = getCookie('MISCGCs', 'UserName');
    return !!userName;
  } catch (e) {
    return false;
  }
}

const getCreditCardApply = () => {
  try {
    return JSON.parse(
      sessionStorage.getItem('creditCardApply'),
    ) || {};
  } catch (e) {
    return {};
  }
};

export default function isCitiRedirect() {
  try {
    const creditCardApply = getCreditCardApply();

    return (
      isApplyNowFlowActive()
      && isSignedInOrSoftSignedIn()
      && !creditCardApply.userHasCard
      && isCurrentPathSame()
    );
  } catch (e) {
    return false;
  }
}
